<template>
  <div>
<el-container style="width: 90%; margin-left: 5%;">
      <el-form ref="form" :model="form" inline="true" class="demo-form-inline">
        <el-form-item label="资产名称">
          <el-input v-model="form.propertyName"></el-input>
        </el-form-item>


        <el-form-item label="资产规格">
          <el-input v-model="form.propertySpecification"></el-input>
        </el-form-item>

        <el-form-item label="资产型号">
          <el-input v-model="form.propertyModel"></el-input>
        </el-form-item>



      <el-divider content-position="left" style="width: 75%;">基本信息</el-divider>

      <el-form-item label="是否为帐外资产">
        <el-select v-model="form.outProperty" placeholder="是否为帐外资产">
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="资产状态">
        <el-select v-model="form.propertyState" placeholder="是否为资产状态">
          <el-option label="闲置" value='1'></el-option>
          <el-option label="使用者" value='2'></el-option>
          <el-option label="审批中" value='3'></el-option>
          <el-option label="报废" value='4'></el-option>
        </el-select>
      </el-form-item>


      <!-- 单位人员树 -->
      <el-form-item label="管理员部门人ID">

        <el-input v-model="form.managerId" :value="ManagerUser">
          <!-- <el-input v-model="form.propertyTypeId" :value="id"> -->
            <el-button
              size="mini"
               style="padding-right:10px"
               slot="suffix"
               type="text"
              @click="dialogManager = true">选择</el-button> </el-input>
              <el-dialog title="选择资产类别" :visible.sync="dialogManager" width="35%">
                <el-tree
                  class ="TreeBlock"
                  :data="MangerData"
                  :filter-node-method="filterNode"
                  node-key="id"
                  @node-click="TreeMangerClick"
                  ref="tree"
                  :props="defaultProps"
                  default-expand-all:false
                  :expand-on-click-node="false">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                  </span>
                </el-tree>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogManager = false">取 消</el-button>
                  <el-button type="primary" @click="dialogManager = false;handleEdit(node.label, data)">确 定</el-button>
                </div>
              </el-dialog>

      </el-form-item>
      <el-divider content-position="left" style="width: 75%;">部门信息</el-divider>

      <!-- 单位人员树 -->
      <el-form-item label="使用者ID">
         <el-input v-model="form.ownerId" :value="User">
                   <!-- <el-input v-model="form.propertyTypeId" :value="id"> -->
                     <el-button
                       size="mini"
                        style="padding-right:10px"
                        slot="suffix"
                        type="text"
                       @click="dialogUser = true">选择</el-button> </el-input>
                       <el-dialog title="选择资产类别" :visible.sync="dialogUser" width="35%">
                         <el-tree
                           class ="TreeBlock"
                           :data="UserData"
                           :filter-node-method="filterNode"
                           node-key="id"
                           @node-click="TreeUserClick"
                           ref="tree"
                           :props="defaultProps"
                           default-expand-all:false
                           :expand-on-click-node="false">
                           <span class="custom-tree-node" slot-scope="{ node, data }">
                             <span>{{ node.label }}</span>
                           </span>
                         </el-tree>
                         <div slot="footer" class="dialog-footer">
                           <el-button @click="dialogUser = false">取 消</el-button>
                           <el-button type="primary" @click="dialogUser = false;handleEdit(node.label, data)">确 定</el-button>
                         </div>
                       </el-dialog>
      </el-form-item>


      <el-form-item label="管理部门ID">

         <el-select v-model="form.managerDeptId" placeholder="请选择管理部门ID">
          <el-option
          v-for="i in DName"
          :label="i.departmentName"
          :key="i.departmentName"
          :value="i.departmentId">

          </el-option>
         </el-select>



      </el-form-item>


      <el-form-item label="使用部门ID">
        <el-select
        v-model="form.ownerDeptId"
        placeholder="请选择使用部门ID">
         <el-option
         v-for="i in DName"
         :key="i.departmentId"
         :label="i.departmentName"
         :value="i.departmentId">

         </el-option>
        </el-select>
      </el-form-item>
       <el-divider content-position="left" style="width: 75%;">使用信息</el-divider>

        <el-form-item label="资产固定编码">
          <el-input v-model="form.propertyCode" placeholder="输入资产固定编码"></el-input>
        </el-form-item>


        <el-form-item label="资产类别ID">
          <el-input v-model="form.propertyTypeId" :value="id">
            <!-- <el-input v-model="form.propertyTypeId" :value="id"> -->
              <el-button
                size="mini"
                 style="padding-right:10px"
                 slot="suffix"
                 type="text"
                @click="dialogPropertyTypeId = true">选择</el-button> </el-input>
                <el-dialog title="选择资产类别" :visible.sync="dialogPropertyTypeId" width="35%">
                  <el-tree
                    class ="TreeBlock"
                    :data="data"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreePropertyClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>

                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPropertyTypeId = false">取 消</el-button>
                    <el-button type="primary" @click="dialogPropertyTypeId = false;handleEdit(node.label, data)">确 定</el-button>
                  </div>
                </el-dialog>

        </el-form-item>

        <el-form-item label="存放区域ID">


          <el-input v-model="form.placeId" :value="PlaceId">
            <!-- <el-input v-model="form.propertyTypeId" :value="id"> -->
              <el-button
                size="mini"
                 style="padding-right:10px"
                 slot="suffix"
                 type="text"
                @click="dialogPlace = true">选择</el-button> </el-input>
                <el-dialog title="选择资产类别" :visible.sync="dialogPlace" width="35%">
                  <el-tree
                    class ="TreeBlock"
                    :data="PlaceData"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreePlaceClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>

                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPlace = false">取 消</el-button>
                    <el-button type="primary" @click="dialogPlace = false;handleEdit(node.label, data)">确 定</el-button>
                  </div>
                </el-dialog>


        </el-form-item>
         <el-divider content-position="left" style="width: 75%;">单位信息</el-divider>

        <el-form-item label="单位编号">
          <el-select v-model="form.unitId" placeholder="请选择使用部门ID">
           <el-option
           v-for="i in DUnit"
           :key="i.unitId"
           :label="i.unitName"
           :value="i.unitId">

           </el-option>
          </el-select>
        </el-form-item>

      </el-form>



      </el-container>

      <div style="margin-top: 2%;">
        <el-button type="primary" @click="onSubmit">立即新增</el-button>
        <el-button>取消</el-button>
      </div>


    </div>

</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'PropertyEdit',
     data () {
       const data = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];


        const PlaceData = [{
                id: 1,
                label: '一级 1',
                children: [{
                  id: 4,
                  label: '二级 1-1',
                  children: [{
                    id: 9,
                    label: '三级 1-1-1'
                  }, {
                    id: 10,
                    label: '三级 1-1-2'
                  }]
                }]
              }];
       return {
        filterText: '',
        id:'',
        PlaceId:'',
        User:'',
        ManagerUser:'',
          defaultProps: {
                   children: 'children',
                   label: 'label'
                 },
         data: JSON.parse(JSON.stringify(data)),
         PlaceData: JSON.parse(JSON.stringify(PlaceData)),
         MangerData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
         defaultProps: {
                  children: 'children',
                  label: 'label'
                },
         UserData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
         dialogUser:false,
         dialogPropertyTypeId:false,
         dialogManager:false,
         dialogPlace:false,
         DName:[{
           departmentId:'',
           departmentName:'',
         }],
         DUnit:[{
           unitName:'',
           unitId:'',
         }],
            form: {
                    propertyName:'',
                    propertyCode:'',
                    propertyTypeId:'',
                    placeId:'',
                    unitId:'',
                    propertySpecification:'',
                    propertyModel:'',
                    outProperty:'',
                    managerId:'',
                    ownerId:'',
                    managerDeptId:'',
                    ownerDeptId:'',
                    propertyState:'',
                  }
        };
     },
     mounted:function() {
		// 首先是当页面加载的时候自动渲染这些数据	
			 
		// 表格里面的数据
       this.showData();
	   // 查询条件里面的数据预加载    区域信息
       this.showPlaceData();
	   // 查询条件里面的数据预加载    部门信息
       this.showDepartmentData();
	   // 查询条件里面的数据预加载    单位信息
       this.showUnitData();
	   // 查询条件里面的数据预加载    人员信息
       this.showMData();
     },


     watch: {
		  // 树状结构的显示核心
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },
     methods: {


	// 获取资产类别信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是资产类别ID
    TreePropertyClick(data){
          this.id = data.id
          this.form.propertyTypeId = data.label
    },

	  // 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
      TreePlaceClick(data){
          this.PlaceId = data.id
          this.form.placeId = data.label
      },
	  // 获取管理人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是管理人ID
      TreeMangerClick(data){
          this.ManagerUser = data.realId
          this.form.managerId = data.label
      },

	  // 获取使用人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是使用人ID
      TreeUserClick(data){
          this.User = data.realId
          this.form.ownerId = data.label
      },



      filterNode(value, data) {
              if (!value) return true;
              return data.label.indexOf(value) !== -1;
            },




		// 点击上传将form里的数据进行上传，form在334
        onSubmit() {
          this.form.placeId = this.PlaceId
          this.form.propertyTypeId = this.id
          this.form.ownerId = this.User
          this.form.outProperty = parseInt(this.form.outProperty)
          this.form.propertyState = parseInt(this.form.propertyState)
          this.form.managerId = this.ManagerUser
		  this.form.del = 1
          var params = this.form


          var authorization = Cookies.get("Authorization");

           this.axios({
               method: 'POST',
               url: '/property/add',
               data:params,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
							if(resp.data.code == 200){
								this.open2(resp.data.message)
							}else{
								this.open3(resp.data.message)
							}
            })
        },
				open2(val) {
				        this.$notify({
				          title: '添加成功',
				          message: val,
				          type: 'success',
				          duration: 3000
				        });
				      },
				open3(val) {
				        this.$notify({
				          title: '添加失败',
				          message: val,
				          type: 'danger',
				          duration: 3000
				        });
				      },


		// 请求小杜接口/public/getCanHandleDepartmentList获取部门信息然后将数据传给DName在129行
        showDepartmentData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getCanHandleDepartmentList',
              params:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.DName = resp.data.data;
             console.log(this.DName)
            })
        },


		// 请求小杜接口public/getTree获取区域信息然后将数据传给PlaceData在191行
        showPlaceData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getTree',

              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{

             this.PlaceData=resp.data.data;
            })
        },





		  // 请求小杜接口public/getTree获取区域信息然后将数据传给MangerData在53行
          showMData(){
           var authorization = Cookies.get("Authorization");
            this.axios({
                method: 'GET',
                url: '/public/getUnitTree',
                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{
               var arr = new Array(resp.data.data) ;
               this.MangerData=resp.data.data;
               this.UserData = resp.data.data;
              })
          },




		  // 主要数据展示给tableData
          showData(){
           var authorization = Cookies.get("Authorization");
           var params = {
             currentPage: 1,
             pageSize: 5,
           }
            this.axios({
                method: 'GET',
                url: '/public/getPropertySortTree',

                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{

               this.data=resp.data.data;


               // this.pageSize=resp.data.count;
              })
          },


		// 请求小杜接口/public/getCanWatchUnit获取单位信息然后将数据传给DUnit在217行
        showUnitData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getCanWatchUnit',
              params:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.DUnit = resp.data.data;
            })
        },
     }
   }
</script>

<style>
  .Tree{
    width: 75%;
    border-style: solid;
    /* margin-top: 2%; */
    border-width: 3px;
    border-radius: 20px;
    border-color: #33CCFF;
  }
  .TreeBlock{
    margin-top: 1.5%;
    margin-left: 1%;
    margin-right: 1%;
    margin-bottom: 1%;
  }


</style>



// WEBPACK FOOTER //
// src/components/Property/Property_Insert.vue